import { WorkBook } from 'xlsx';

export interface WorkBookFileData {
	name: string;
	file: WorkBook;
}
